import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-filter-icon-shared',
  templateUrl: './filter-icon-shared.component.html'
})
export class FilterIconSharedComponent {}
